var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCircletick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 272 272",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M257.276 150.425C247.585 198.88 211.052 244.498 159.772 254.698C108.491 264.899 56.4529 241.046 30.7065 195.539C4.96008 150.033 11.3162 93.1423 46.471 54.44C81.6259 15.7375 140.985 5.06037 189.439 24.4423",
    stroke: "black",
    strokeWidth: 29.073,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5278 131.044L140.983 179.498L257.275 53.5156",
    stroke: "black",
    strokeWidth: 29.073,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircletick);
export default __webpack_public_path__ + "static/media/icon _circle tick_.8ca70bb2bcf9968a3125a7341ea0392a.svg";
export { ForwardRef as ReactComponent };